<template>
	<div class="body-container" :class="addressModal ? 'modal-open' : ''">
		<headerNavigation :showLogin="false"></headerNavigation>
		<template v-if="isMobile">
			<div class="global-header-spacer display-mobile" style="height: 0px;" ></div>
			<div class="div-after-fixed-header" style="height: 103px;"></div>
		</template>
		<div class="site-main-container">
			<div class="page-portal-container container">
				<div class="site-container">
					<userHeader :subMenuIndex="1"></userHeader>
					<div class="comp-settings-contact-information-container">
						<div class="comp-settings-left-nav-container hidden-xs hidden-sm">
							<ul class="left-nav-list list-group aria-parent-nav">
								<li class="left-nav-item list-group-item aria-child-nav aria-left-nav">
									<a href="javascript:void(0)" @click="openPage('user')">
										<span class="left-nav-label pull-left">{{$t('common.accountdetail')}}</span>
										<img src="../../assets/images/right.png" class="left-nav-i dri-arrow-right right-icon"/>
									</a>
								</li>
								<li class="left-nav-item list-group-item aria-child-nav aria-left-nav">
									<a href="javascript:void(0)" @click="openPage('password')">
										<span class="left-nav-label pull-left">{{$t('user.changepassword')}}</span>
										<img src="../../assets/images/right.png" class="left-nav-i dri-arrow-right right-icon"/>
									</a>
								</li>
								<li class="left-nav-item list-group-item aria-child-nav aria-left-nav">
									<a href="javascript:void(0)" @click="openPage('address')">
										<span class="left-nav-label pull-left">{{$t('user.addressbook')}}</span>
										<img src="../../assets/images/right.png" class="left-nav-i dri-arrow-right right-icon"/>
									</a>
								</li>
								<li class="left-nav-item list-group-item aria-child-nav aria-left-nav">
									<a href="javascript:void(0)" class="active-sub-tab">
										<span class="left-nav-label pull-left">{{$t('user.paymentmethod')}}</span>
										<img src="../../assets/images/right.png" class="left-nav-i dri-arrow-right right-icon"/>
									</a>
								</li>
							</ul>
						</div>
						<div class="comp-settings-left-nav-mobile-container hidden-md hidden-lg">
							<div class="left-nav-mobile-container collapse navbar-collapse">
								<ul class="left-nav-ul nav navbar-nav" >
									<li class="left-nav-dropdown dropdown" :class="showSubMenu ? 'open' : ''">
										<a href="javascript:void(0)" class="left-nav-active-page dropdown-toggle" @click="changeSubMenu">
											<span class="left-nav-active-label">{{$t('user.paymentmethod')}}</span>
											<img src="../../assets/images/arrow-down.png" class="dri-arrow-down dropdown-icon pull-right down-icon"/>
										</a>
										<ul class="left-nav-subnav dropdown-menu">
											<li class="left-nav-links">
												<a href="javascript:void(0)" @click="openPage('user')" class="left-nav-url">{{$t('common.accountdetail')}}</a>
											</li>
											<li class="left-nav-links">
												<a href="javascript:void(0)" @click="openPage('password')" class="left-nav-url">{{$t('user.changepassword')}}</a>
											</li>
											<li class="left-nav-links">
												<a href="javascript:void(0)" @click="openPage('address')" class="left-nav-url">{{$t('user.addressbook')}}</a>
											</li>
											<li class="left-nav-links">
												<a href="javascript:void(0)" class="left-nav-url">{{$t('user.paymentmethod')}}</a>
											</li>
										</ul>
									</li>
								</ul>
							</div>
						</div>
						<div class="contact-information-container">
							
							<p>{{$t('user.notpaymethod')}}</p>
							<div class="customer-address-pagination top-part">
								<button class="site-btn-primary add-new-address first-focus-element" @click="openModal">{{$t('user.addpaymethod')}}</button>
							</div>
							<div class="customer-address-list">
								<div class="customer-address">
									<div class="address-border">
										<div class="address-container">
											<div class="address-item-contents">
												<ul class="address-info">
													<li class="title">1234 1234 1234 134</li>
													<li class="attention">&nbsp;</li>
													<li class="address1">2025/12/25</li>
													<li class="address1">SOUHFS</li>
													<li class="address-group">Elkins Park, PA 19027</li>
												</ul>
											</div>
										</div>
										<div class="address-action-container">
											<div>
												<button class="edit-btn-9267921 site-btn-primary">{{$t('common.edit')}}</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-backdrop fade in" v-if="showModal"></div>
		<div class="modal fade in" style="display: block;" v-if="showModal">
			<div class="address-modal modal-dialog">
				<div class="modal-content">
					<div class="modal-main">
						<div class="modal-header">
							<button class="modal-close-btn close close-shipping-modal" @click="closeModal">
								<span>×</span>
							</button>
							<div class="modal-title">
								<h4 class="address-modal-header ng-star-inserted">{{$t('common.paymentmethod')}}</h4>
								<span class="address-form-required-label">*{{$t('user.creditcarddebitcard')}}</span>
							</div>
						</div>
						<div class="modal-body comp-shipping-address-container">
							<div class="portal-address-book-form-container">
								<div class="comp-address-form-container">
									<div class="shipping-address-form ng-pristine ng-valid ng-touched">
										<div class="AnimatePresence">
											<div class="p-LinkAutofillPrompt">
												<div class="AnimateSinglePresence">
													<div class="p-LinkAutofillPromptButton" @click="changePLink">
														<img src="../../assets/images/lock.png" class="lock-icon"/>
														<span class="p-LinkAutofillPromptButton-txt">{{$t('user.safelinkpay')}}</span>
														<img src="../../assets/images/down.png" class="p-down-icon"/>
													</div>
												</div>
											</div>
										</div>
										<div class="coupon-input-group site-form-group" v-if="showPLikn">
											<div class="site-input-group">
												<input type="text" :placeholder="$t('login.email')" class="site-form-input name-input form-control plink-input">
												<div class="p-link">
													<svg overflow="visible" viewBox="0 0 72 24" height="100%" xmlns="http://www.w3.org/2000/svg" role="presentation" focusable="false" fill="#000" opacity="0.3" class="p-Logo p-Logo--light p-Logo--md p-LinkLogo"><path d="M36.12 3.68a2.07 2.07 0 0 1 4.14 0c0 1.12-.92 2.07-2.07 2.07a2.06 2.06 0 0 1-2.07-2.07M29.98 1.92h3.6v20.16h-3.6zM40 7.68h-3.62v14.4H40zM66.1 14.39a12 12 0 0 0 5.32-6.71h-3.63a8.9 8.9 0 0 1-5.5 5V1.93h-3.63v20.16h3.63v-6c2.77.7 4.96 3.09 5.7 6h3.66c-.56-3.06-2.65-5.91-5.55-7.69M46.44 9.3a5.7 5.7 0 0 1 4.3-2 5 5 0 0 1 5.13 5.14v9.64h-3.63v-8.84c0-1.27-.56-2.74-2.4-2.74-2.16 0-3.4 1.92-3.4 4.16v7.42H42.8V7.7h3.63zM12 24a12 12 0 1 0 0-24 12 12 0 0 0 0 24"></path><path fill="#fff" d="M11.45 4.8h-3.7A12 12 0 0 0 13.2 12a12 12 0 0 0-5.45 7.2h3.7a8.6 8.6 0 0 1 6.57-5.7v-3a8.5 8.5 0 0 1-6.57-5.7"></path></svg>
												</div>
											</div>
										</div>
										<div class="company-column site-form-group has-error form-group has-value">
											<label class="site-input-label">*{{$t('user.cardnumber')}}:</label>
											<input type="text" placeholder="1234 1234 1234 1234" class="site-form-input form-control input-address ng-pristine ng-valid ng-touched"/>
										</div>
										<div style="width: 100%;position: relative;overflow: hidden;">
											<div class="zip-code-column site-form-group form-group has-value">
												<label class="site-input-label">*{{$t('user.expirationdate')}}:</label>
												<input type="text" :placeholder="$t('tips.pleaseinputexpirationdate')" class="site-form-input form-control input-address ng-untouched ng-pristine ng-valid"/>
											</div>
											<div class="state-column site-form-group form-group has-value">
												<label class="site-input-label">*{{$t('user.cvc')}}:</label>
												<input type="text" :placeholder="$t('tips.pleaseinputcvc')" class="site-form-input form-control input-address ng-untouched ng-pristine ng-valid"/>
											</div>
										</div>
										<div class="company-column site-form-group form-group has-value">
											<label class="label-timezone">*{{$t('address.countryregion')}}:</label>
											<div class="site-custom-select">
												<select class="select-input ng-pristine ng-valid ng-touched">
													<option disabled="" value="">{{$t('tips.selectanoption')}}</option>
													<option value="AL">阿尔巴尼亚</option>
													<option value="DZ">阿尔及利亚</option>
													<option value="AF">阿富汗</option>
													<option value="AR">阿根廷</option>
													<option value="AE">阿拉伯联合酋长国</option>
													<option value="AW">阿鲁巴</option>
													<option value="OM">阿曼</option>
													<option value="AZ">阿塞拜疆</option>
													<option value="AC">阿森松岛</option>
													<option value="EG">埃及</option>
													<option value="ET">埃塞俄比亚</option>
													<option value="ZM">赞比亚</option>
													<option value="JE">泽西岛</option>
													<option value="TD">乍得</option>
													<option value="GI">直布罗陀</option>
													<option value="CL">智利</option>
													<option value="CF">中非共和国</option>
													<option value="CN">中国</option>
													<option value="MO">中国澳门特别行政区</option>
													<option value="HK">中国香港特别行政区</option>
												</select>
												<img src="../../assets/images/arrow-down.png" class="select-icon fa fa-angle-down down-icon"/>
											</div>
										</div>
										
									</div>
								</div>
							</div>
							<button class="site-btn-primary js-end-trap">{{$t('common.save')}}</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<footers></footers>
	</div>
</template>

<script>
	import headerNavigation from '../../components/headerNavigation.vue'
	import footers from '../../components/footers.vue'
	import userHeader from '../../components/userHeader.vue'
	export default {
		components: {
			headerNavigation,
			footers,
			userHeader
		},
		data() {
			return {
				isMobile:false,
				showSubMenu:false,
				showModal:false,
				showPLikn:false
			};
		},
		mounted() {
		},
		created() {
			this.isMobile = this.webIsMobile()
		},
		methods: {
			changeSubMenu(){
				this.showSubMenu = !this.showSubMenu
			},
			openModal(){
				this.showModal = true
			},
			closeModal(){
				this.showModal = false
			},
			changePLink(){
				this.showPLikn = !this.showPLikn
			}
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/user.css");
	@import url("../../assets/css/address.css");
	.global-header-spacer {
	    height: 50px !important;
	    display: block !important;
	}
</style>